import { z } from "zod";

import { fetchWithThrow } from "@rosette/web_utils/src/fetchWithThrow.js";


export const RevokeAllAchievementsRequest = z.object({
    userPublicID: z.string(),
});
export type RevokeAllAchievementsRequest = z.infer<typeof RevokeAllAchievementsRequest>;


export const RevokeAllAchievementsResponse = z.object({
    success: z.boolean(),
});
export type RevokeAllAchievementsResponse = z.infer<typeof RevokeAllAchievementsResponse>;


export async function revokeAllAchievements(userPublicID: string): Promise<void> {
    const request: RevokeAllAchievementsRequest = {
        userPublicID,
    };
    const response = await fetchWithThrow("/api/admin/revokeAllAchievements", {
        method: "POST",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
    });
    RevokeAllAchievementsResponse.parse(await response.json());
}
